import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SComparisonSection = styled.div`
  ${setFlexDFFDC};
`;
